import { t, type MessageKey } from '@aquabox/shared';

/**
 * Dönem ETİKET sözlüğü — yalnız metin. Dönemin tarih aralığını hesaplamak ekranın işi
 * (saat dilimi kuralı: `Europe/Istanbul`, CLAUDE.md kural 8). Ekranlar desteklediği alt kümeyi
 * `PERIOD_ORDER` sırasına göre gösterir.
 */
export type PeriodKey =
  'today' | 'yesterday' | 'thisWeek' | 'last7' | 'last30' | 'thisMonth' | 'all' | 'custom';

export const PERIOD_ORDER: readonly PeriodKey[] = [
  'today',
  'yesterday',
  'thisWeek',
  'last7',
  'last30',
  'thisMonth',
  'all',
  'custom',
];

const LABEL_KEY: Record<PeriodKey, MessageKey> = {
  today: 'period.today',
  yesterday: 'period.yesterday',
  thisWeek: 'period.thisWeek',
  last7: 'period.last7',
  last30: 'period.last30',
  thisMonth: 'period.thisMonth',
  all: 'period.all',
  custom: 'period.custom',
};

export function periodLabel(key: PeriodKey): string {
  return t(LABEL_KEY[key]);
}
